<template>
  <a-layout>
    <a-tabs v-model="activeKey" style="margin-top: -4px">
      <a-tab-pane key="1" :tab="refundable?$t('business.label.returnList'):$t('business.label.receivingList')" style="margin-top: -14px">
        <ReceiptQuery ref="receiptQuery" :order-status-data="orderStatusData" :refundable="refundable" :storer-data="storerData" @rowDblClick="rowDblClick" />
      </a-tab-pane>
      <a-tab-pane key="2" :tab="refundable?$t('business.label.saleReturn'):$t('business.label.receiving')" forceRender style="margin-top: -14px">
        <ReceiptEdit ref="receiptEdit" :order-status-data="orderStatusData" :refundable="refundable" :storer-data="storerData" @editDetailSuccess="editDetailSuccess" @saveFinish="saveFinish" @saveStart="saveStart" />
      </a-tab-pane>
      <a-space slot="tabBarExtraContent">
        <a-button type="primary" @click="reset" :disabled="resetDisabled">{{ $t('button.reset') }}</a-button>
        <a-button type="primary" @click="supervise" :disabled="superviseDisabled">{{ $t('button.scanSupervisorCode') }}</a-button>
        <a-button type="primary" @click="baseDataEdit" :disabled="baseDataEditDisabled || !$refs.receiptEdit.editable">{{ $t('button.dataMaintenance') }}</a-button>
        <a-button type="primary" @click="save" :loading="saveLoading" :disabled="saveDisabled || !$refs.receiptEdit.editable">{{ $t('button.save') }}</a-button>
        <a-button type="primary" @click="pickUp" :disabled="pickUpDisabled || !$refs.receiptEdit.editable">{{ $t('button.taken') }}</a-button>
        <a-button type="primary" @click="rejectPrint" :disabled="rejectPrintDisabled">{{ $t('button.printRejectLabel') }}</a-button>
      </a-space>
    </a-tabs>
  </a-layout>
</template>

<script>
  import ReceiptQuery from '@/views/inbound/receipt/ReceiptQuery'
  import ReceiptEdit from '@/views/inbound/receipt/ReceiptEdit.vue'
  import ReceiptPickupModal from '@/views/inbound/receipt/modal/ReceiptPickupModal.vue'
  import { findAll, findEnum } from '@/api/Api'

  export default {
    name: 'Receipt',
    components: {
      ReceiptPickupModal,
      ReceiptEdit,
      ReceiptQuery
    },
    props: {
      refundable: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        activeKey: '1',
        resetDisabled: false,
        superviseDisabled: true,
        baseDataEditDisabled: true,
        saveDisabled: true,
        pickUpDisabled: true,
        rejectPrintDisabled: true,
        receiptView: false,
        saveLoading: false,
        orderStatusData: [],
        storerData: []
      }
    },
    watch: {
      activeKey(key) {
        switch (key) {
          case '1':
            this.resetDisabled = false
            this.superviseDisabled = true
            this.baseDataEditDisabled = true
            this.saveDisabled = true
            this.pickUpDisabled = true
            this.rejectPrintDisabled = true
            break
          case '2':
            this.resetDisabled = false
            this.superviseDisabled = false
            this.baseDataEditDisabled = false
            this.saveDisabled = false
            this.pickUpDisabled = false
            this.rejectPrintDisabled = false
            break
        }
      }
    },
    mounted() {
      findAll('storerFactory', { available: true }).then(res => {
        if (res.success) {
          this.storerData = res.result
        }
      })
      findEnum('OrderStatus').then(res => {
        if (res.success) {
          this.orderStatusData = res.result
        }
      })
    },
    methods: {
      reset() {
        if (this.activeKey === '1') {
          this.$refs.receiptQuery.reset()
        } else {
          let that = this
          this.$confirm({
            title: '是否确认重置?',
            content: '将清空界面收货信息',
            onOk() {
              that.receiptView = false
              that.$refs.receiptEdit.clear()
            },
            onCancel() {
            },
            centered: true
          })
        }
      },
      rowDblClick(row) {
        this.activeKey = '2'
        this.receiptView = true
        this.$refs.receiptEdit.clearDetail()
        this.$refs.receiptEdit.pickUpByReceiptDetail(row)
      },
      supervise() {
        this.$refs.receiptEdit.openSupervisedModal()
      },
      baseDataEdit() {
        this.$refs.receiptEdit.openReceiptMaintain()
      },
      save() {
        this.$refs.receiptEdit.saveReceipt()
      },
      saveStart() {
        this.saveLoading = true
      },
      saveFinish() {
        this.saveLoading = false
      },
      pickUp() {
        this.$refs.receiptEdit.openOrderPickUp()
      },
      rejectPrint() {
        this.$refs.receiptEdit.print()
      },
      editDetailSuccess() {
        this.$refs.receiptQuery.rowClick()
      }
    }
  }
</script>

<style scoped>

</style>